<div class="flex h-full flex-col gap-2">
  @if (asins() === undefined) {
    <ISpinner [display]="true" />
  } @else {
    <div class="flex min-h-0 flex-1 flex-col gap-2">
      <app-asin-selection class="min-h-0 flex-1" [customList]="asins()" [readonly]="true" [csvExport]="true" />
    </div>
  }

  <div class="flex justify-end gap-2" *transloco="let t">
    <button iButton variant="ghost" size="md" (click)="close()">{{ t("common.cancel") }}</button>
    <button iButton size="md" (click)="openCatalog()">{{ t("common.see_in_catalog") }}</button>
  </div>
</div>
